import LottoDemoService from '../services/lotto-demo'

const mutations = {
    SET_CURRENT_ROUND(state, round) {
        state.currentRound = round
    },
    SET_IS_FETCHING_CURRENT_ROUND(state, isFetching) {
        state.isFetchingCurrentRound = isFetching
    },
    SET_IS_FETCHING_BET_LIST(state, isFetching) {
        state.isFetchingBetList = isFetching
    },
    SET_BET_LIST(state, betList) {
        state.betList = betList
    },
    SET_PREVIEW_WINNER(state, winner) {
        state.previewWinner = winner
    }
}

const state = {
    currentRound: null,
    isFetchingCurrentRound: false,
    isFetchingBetList: false,
    betList: [],
    previewWinner: null
}

const actions = {
    async toggleLottoDemoBetStatus({ dispatch }) {
        try {
            await LottoDemoService.toggleBetStatus()
            dispatch('notifySuccess')
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async fetchCurrentLottoDemo({ dispatch, commit }) {
        try {
            commit('SET_IS_FETCHING_CURRENT_ROUND', true)
            const res = await LottoDemoService.getCurrentRound()
            commit('SET_CURRENT_ROUND', res.id ? res : null)
        } catch (e) {
            dispatch('notifyError', e)
            commit('SET_CURRENT_ROUND', null)
        } finally {
            commit('SET_IS_FETCHING_CURRENT_ROUND', false)
        }
    },
    async fetchLottoDemoBetList({ dispatch, commit }, id) {
        try {
            commit('SET_IS_FETCHING_BET_LIST', true)
            const res = await LottoDemoService.getBetList(id)
            commit('SET_BET_LIST', res)
        } catch (e) {
            dispatch('notifyError', e)
        } finally {
            commit('SET_IS_FETCHING_BET_LIST', false)
        }
    },
    async createNewLottoDemoRound({ dispatch }, data) {
        try {
            await LottoDemoService.openNewRound(data)
            dispatch('notifySuccess')
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async updateLottoDemoRound({ dispatch }, data) {
        try {
            await LottoDemoService.updateRound(data)
            dispatch('notifySuccess')
        } catch (e) {
            dispatch('notifyError', e)
        }
    },
    async fetchPreviewWinner({ dispatch, commit }, betNumber) {
        try {
            const res = await LottoDemoService.submitResult(betNumber, true)
            commit('SET_PREVIEW_WINNER', res)
        } catch (e) {
            commit('SET_PREVIEW_WINNER', null)
            dispatch('notifyError', e)
        }
    },
    async resetPreviewWinner({ commit }) {
        commit('SET_PREVIEW_WINNER', null)
    },
    async submitLottoDemoResult({ dispatch }, betNumber) {
        try {
            return await LottoDemoService.submitResult(betNumber, false)
        } catch (e) {
            dispatch('notifyError', e)
        }
    }
}

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters
}